<template>
    <div>
        <b-modal
            id="add-relationship-popup"
            ref="modal"
            :title="titleHeading"
            size="sm"
            no-close-on-backdrop
            hide-footer
            modal-class="hide-footer"
            :hide-header-close="loading"
            no-close-on-esc
            @hidden="onHidden"
        >
            <b-form
                @submit.stop.prevent="onSubmit()"
                @reset.stop.prevent="onHidden"
            >
                <div class="row custom-model-form">
                    <div class="col-md-12">
                        <label for="select-1"> Rule (in Months)</label>
                    </div>

                    <div class="col-md-6">
                        <b-form-group id="rule-month-min">
                            <b-form-input
                                id="rule-month-min-input"
                                v-model.number="formData.monthRange.minimum"
                                v-validate="{
                                    required: true,
                                    regex: /^([0-9]*)$/,
                                    min: 1,
                                    max: 4,
                                }"
                                type="number"
                                placeholder="Enter Minimum range"
                                name="minimum"
                                :class="{
                                    'is-invalid': errors.has('minimum'),
                                }"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-md-6 months-length">
                        <b-form-group id="rule-month-max">
                            <b-form-input
                                id="rule-month-max-input"
                                v-model.number="formData.monthRange.maximum"
                                v-validate="{
                                    required: true,
                                    regex: /^([0-9]*)$/,
                                    min: 1,
                                    max: 4,
                                }"
                                type="number"
                                placeholder="Enter maximum range"
                                name="maximum"
                                :class="{
                                    'is-invalid': errors.has('maximum'),
                                }"
                            ></b-form-input>
                        </b-form-group>
                    </div>

                    <div class="col-md-12">
                        <b-form-group
                            id="relationship-length-title"
                            label="Relationship Length Title"
                            label-for="Relationship Length Title"
                        >
                            <b-form-input
                                id="relationship-length-title-input"
                                v-model="formData.title"
                                v-validate="{
                                    required: true,
                                }"
                                type="text"
                                placeholder="Enter relationship length title"
                                name="title"
                                :class="{
                                    'is-invalid': errors.has('title'),
                                }"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-md-12">
                        <b-form-group
                            id="input-group-3"
                            label="Rating"
                            label-for="rating"
                        >
                            <b-form-select
                                id="rating"
                                v-model="formData.rating"
                                v-validate="{
                                    required: true,
                                }"
                                name="rating"
                                class="form-control"
                                :class="{
                                    'is-invalid': errors.has('rating'),
                                }"
                                :options="rating"
                            ></b-form-select>
                        </b-form-group>
                    </div>
                </div>
                <div class="col-md-12 action-buttons">
                    <base-button
                        :btn-label="buttonLabel"
                        btn-type="submit"
                        btn-variant="primary"
                        :class="loading ? 'disabled' : ''"
                    ></base-button>
                    <base-button
                        btn-label="Cancel"
                        btn-type="reset"
                        btn-variant="link"
                        :disabled="loading"
                    ></base-button>
                </div>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        title: {
            type: String,
            default: null,
        },
        buttonText: {
            type: String,
            default: 'Create',
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['loading', 'selectedItem', 'hidePopup']),
        titleHeading() {
            return this.selectedItem
                ? 'Modify Relationship Length Factor'
                : 'Add Relationship Length Factor'
        }, // End of title() method

        buttonLabel() {
            return this.selectedItem ? 'Update' : 'Create'
        },
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            formData: this.initializeFormData(),

            rating: [
                { value: null, text: 'Select Rating' },
                { value: 'high', text: 'High Risk' },
                { value: 'medium', text: 'Medium Risk' },
                { value: 'low', text: 'Low Risk' },
            ],
        }
    },
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        /**
         * Handle when the selected has been updated
         *
         * @return {void}
         */
        selectedItem(value) {
            if (value !== null && value !== undefined) {
                Object.assign(this.formData, JSON.parse(JSON.stringify(value)))
            } else {
                this.onHidden()
            }
        },
        /**
         * Handle when the popup hide
         *
         * @return {void}
         */
        hidePopup(value) {
            if (value) {
                this.onHidden()
            }
        },
    },
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        initializeFormData() {
            return {
                _id: null,
                title: '',
                rating: null,
                monthRange: { minimum: null, maximum: null },
            }
        }, // End of initializeFormData() method
        /**
         * Handle when the modal is closed
         *
         * @return {void}
         */
        onHidden() {
            // clear the selected item
            this.$store.commit('clearItem')
            this.$store.commit('onSubmit', null)
            Object.assign(this.formData, this.initializeFormData())
            this.$validator.reset()
            this.$refs.modal.hide()
        }, // End of onHidden() method
        /**
         * Handle when the modal is canceled
         *
         * @return {void}
         */
        async onSubmit() {
            const result = await this.$validator.validateAll()
            if (result) {
                try {
                    await this.$store.dispatch('onSubmit', this.formData)
                } catch (error) {
                    //console.log(error, 'There is an error on submit')
                }
            } else {
                this.$store.commit('setError', this.errors.all()[0])
            }
        }, // End of onSubmit() method
    }, // End of Component > watch
}
</script>
